import { instanceOf, string } from 'prop-types'
import cn from 'classnames'

import localizedPostTime from '../../../../utilities/localizedPostTime.js'
import CardsSocialCommerceButton from './cards-social-commerce-button.js'
import Post from '../../../../../models/Post.js'
import Settings from '../../../../../models/settings.js'
import UserProfileImage from '../../theme-components/user-profile-image.js'

export default function FeedSubImageContributorDetails({ feedKey, post, settings }) {
  const { socialCommerceButtonPosition } = settings
  if (!settings.isCenteredTheme) {
    return null
  }

  const postHasImage = (post.media || []).some(({ type }) => type === 'image')
  const { key, ...restPostProps } = post

  return (
    <div
      aria-hidden="true"
      className={cn('bzfy-o-header', 'bzfy-o-header--center', 'bzfy-o-header--cards-center', {
        'bzfy-o-header--no-post-image': !settings.showProfileImage,
        'bzfy-o-header--cards-center-no-post-image': !postHasImage,
      })}
    >
      {settings.showProfileImage && (
        <div className="bzfy-o-header__row">
          <UserProfileImage
            key={key}
            {...restPostProps}
            className="bzfy-o-header__image"
            source={post.sourceName}
          />
        </div>
      )}
      {settings.displayName && <div className="bzfy-o-header__user">{post.userName}</div>}
      {settings.postAge && (
        <div className="bzfy-o-header__time">{localizedPostTime(post, settings.locale)}</div>
      )}
      <div className="bzfy-o-header__row">
        {socialCommerceButtonPosition === 'top' && (
          <CardsSocialCommerceButton feedKey={feedKey} post={post} settings={settings} />
        )}
      </div>
    </div>
  )
}

FeedSubImageContributorDetails.propTypes = {
  feedKey: string.isRequired,
  post: instanceOf(Post).isRequired,
  settings: instanceOf(Settings).isRequired,
}
